
const mapValidationKeys = (props = [], {object, event} = { object: 'data', event: 'update'}) => {

	return props.reduce((obj, prop) => {

		let prop_message 	= prop + '_err';
		let prop_has 		= prop + '_has_err';

		let error_message_prop = {

			get() {
				
				let message_index = this.validationMessages.findIndex( message => {
					if( message.hasOwnProperty(prop) ){ return message }
				});

				if(message_index > -1){
					return this.validationMessages[message_index][prop];
				}

				return '';

			}
 
		}

		let error_has_prop = {

			get() {
				
				let message_index = this.validationMessages.findIndex( message => {
					if( message.hasOwnProperty(prop) ){ return message; }
				});

				if(message_index > -1) return true
				
				return false;

			}
 
		}

		obj[prop_message] = error_message_prop
		obj[prop_has] = error_has_prop

		return obj

	}, {})
}

const Validation = {


	data: function () {
		return {
			validationResponse:null,
			validationMessages:[],
			errorKeys:[]
		}
	},

	computed:{
		
		valErr:{

			get(){
				return this.validationMessages
			},

			set(exception){

				if(!exception instanceof Error) throw new Error('Object is not instance of Error')
					this.validationResponse = exception;
				if( !exception.hasOwnProperty('response') ){
					return false;
				}

				if( exception.response.hasOwnProperty('data') && exception.response.data.hasOwnProperty('err') ) {
					this.validationMessages = exception.response.data.err;
				}

			}
			
		}

	}

}

export default {
	Validation:Validation,
	mapValidationKeys:mapValidationKeys
}